import gql from "graphql-tag";

export const GetOrganizationInfo = gql`
  query GetOrganizationInfo {
    accounts {
      id
      picture
      bio
      name
      website
      contactNumber
      isTaxIdProvided
      type
      sendbirdToken
      isNmiAccount
      originAddress {
        id
        city
        postalCode
        phone
        street1
        state {
          id
          name
        }
      }
    }
  }
`;

export const GetStates = gql`
  query getStates {
    states {
      id
      name
    }
  }
`;
